import {
    AixAction,
    BundleCandidatesResponse,
    ErrorWrapper,
    OrderIdPayload,
    type
} from '@trade-platform/ui-shared';

export class OrderBundleCandidatesActionTypes {
    static readonly ORDER_BUNDLE_CANDIDATES_LOAD = type('[Order Bundle Candidates] Load');
    static readonly ORDER_BUNDLE_CANDIDATES_LOAD_SUCCESS = type(
        '[Order Bundle Candidates] Load Success'
    );
    static readonly ORDER_BUNDLE_CANDIDATES_LOAD_FAILURE = type(
        '[Order Bundle Candidates] Load Failure'
    );
    static readonly ORDER_BUNDLE_CANDIDATES_RESET = type('[Order Bundle Candidates] Reset');
}

export type OrderBundleCandidatesActions =
    | OrderBundleCandidatesLoad
    | OrderBundleCandidatesLoadSuccess
    | OrderBundleCandidatesLoadFailure
    | OrderBundleCandidatesReset;

export class OrderBundleCandidatesLoad implements AixAction {
    readonly type = OrderBundleCandidatesActionTypes.ORDER_BUNDLE_CANDIDATES_LOAD;

    constructor(public payload: OrderIdPayload) {}
}

export class OrderBundleCandidatesLoadSuccess implements AixAction {
    readonly type = OrderBundleCandidatesActionTypes.ORDER_BUNDLE_CANDIDATES_LOAD_SUCCESS;

    constructor(public payload: BundleCandidatesResponse) {}
}

export class OrderBundleCandidatesLoadFailure implements AixAction {
    readonly type = OrderBundleCandidatesActionTypes.ORDER_BUNDLE_CANDIDATES_LOAD_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class OrderBundleCandidatesReset implements AixAction {
    readonly type = OrderBundleCandidatesActionTypes.ORDER_BUNDLE_CANDIDATES_RESET;
}
